export enum FanControlMode {
    OnOff = "OnOff",
    Staged = "Staged",
    SteppedSpeed = "SteppedSpeed",
    VariableVaneAngle = "VariableVaneAngle",
    VFD = "VFD",
}